import ApiBase from "../api-base";

class MeApi extends ApiBase {

    async me() {
        const response = await this.get('/users/me');
        return response.data.data;
    }


    async update(params, validationCallback = this.defaultValidationHandler) {
        const response = await this.post('/users/me', params, validationCallback);
        
        return response;
    }

    async notifications(params) {
        const response = await  this.get('/users/me/notifications');

        return response.data;
    }

    async notificationsCount() {
        const response = await  this.get('/users/me/notifications/count');

        return response.data;
    }

    async notificationsMarkAllRead() {
        const response = await this.post('/users/me/notifications/mark-all-read', {});
        return response.data.data;
    }


}

export default new MeApi();
